import React, { PropTypes } from 'react'
import { Button, InputNumber, Row, List, Card, Input, Modal, Select, Form } from 'antd';
import { EyeOutlined, EditOutlined } from '@ant-design/icons';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { db } from '../services/firebase';
import domtoimage from 'dom-to-image';


const { Option } = Select;
const { Search } = Input;
const { Meta } = Card;

const Searchbar = () => {
    const [pdf, setPdf] = React.useState(false);
    const [modalPagina, setModalPagina] = React.useState(false);
    const [modalVehiculo, setModalVehiculo] = React.useState(false);
    const [vehiculo, setVehiculo] = React.useState([]);
    const [vehiculos, setVehiculos] = React.useState([]);
    const [vehiculos2, setVehiculos2] = React.useState([])
    React.useEffect(() => {
        const obtenerDatos = async () => {
            try {
                const data = await db.collection('vehiculos').get()
                const arrayData = data.docs.map(doc => ({ busq: doc.data().marca + ' ' + doc.data().modelo, id: doc.id, ...doc.data() }))
                setVehiculos(arrayData)
                setVehiculos2(arrayData)
            } catch (error) {
                console.log(error)
            }
        }
        obtenerDatos();
    }, [])

    const modal = item => {
        setVehiculo(item)
        setModalVehiculo(true)
    }

    const pdfrecibo = async () => {
        await setPdf(true)
        const input = document.getElementById('divToOfferInfo');
        const pdf = new jsPDF();
        if (pdf) {
            domtoimage.toPng(input)
                .then(imgData => {
                    setPdf(false)
                    pdf.addImage(require('../img/logo-blanco.png'), 'PNG', 10, 10, 40, 40)
                    pdf.addImage(imgData, 'PNG', 10, 45, 190, 190);
                    pdf.save('recibo.pdf');
                });
        }
    };

    return (
        <div className="container">
            <div className="main-title text-center">
                <h1>Busca tu modelo ideal</h1>
                <Button type='primary' onClick={() => setModalPagina(true)}><p style={{ color: '#fff' }}>Abrir sitio</p></Button>
            </div>
            <div className="main-title text-center" style={{ width: '100%' }}>
                <Search
                    style={{ width: '100%' }}
                    placeholder="Busca tu nuevo vehiculo aqui"
                    onChange={e =>
                        setVehiculos(vehiculos2.filter(item => {
                            return item.busq.toUpperCase().includes(e.target.value.toUpperCase())
                        }))
                    }
                />
            </div>
            <div className="main-title text-center">
                <List
                    size='large'
                    grid={{ gutter: 0, column: 4 }}
                    pagination={{
                        onChange: page => {
                            console.log(page);
                        },
                        pageSize: 4,
                    }}
                    dataSource={vehiculos}
                    renderItem={item => (
                        <List.Item
                            key={item.servicio}
                        >
                            <Card
                                cover={
                                    <img
                                        alt="example"
                                        src={item.logo}
                                        style={{ height: 150 }}
                                    />
                                }
                                actions={[
                                    <React.Fragment>
                                        <EyeOutlined key="eye" onClick={
                                            () => modal(item)
                                        } />
                                        Descargar cotizacion
                                    </React.Fragment>
                                ]}
                            >
                                <strong>{item.marca + " " + item.modelo}</strong>
                                <p>${item.precio}</p>
                                <Meta
                                    description={item.descripcion}
                                />
                            </Card>
                        </List.Item>
                    )}
                />
            </div>
            <Modal
                width='60%'
                visible={pdf}
            >
                <div id='divToOfferInfo'>
                    <img width='10%' src={require('../img/logo-blanco.png')} />
                    <h4>WTI Services Juarez</h4>
                    <ul className="contact-info">
                        <li>
                            <i className="flaticon-pin"></i>Plaza Bonita Av. Tecnologico 5350 Local 10
                        </li>
                        <li>
                            <i className="flaticon-mail"></i><a href="mailto:sales@hotelempire.com">info@wtiserviciosaduanales.com</a>
                        </li>
                        <li>
                            <i className="flaticon-phone"></i><a href="tel:+526564415210">+52 656 441 5210</a>
                        </li>
                        <li>
                            <i className="flaticon-fax"></i>+52 656 441 5210
                        </li>
                    </ul>
                    <table border="1">
                        <tbody>
                            <tr>
                                <td>Cantidad</td>
                                <th>Descripcion</th>
                                <th>Precio</th>
                            </tr>
                            <tr>
                                <th>1</th>
                                <td>
                                    <p>Marca: {vehiculo.marca}</p>
                                    <p>Modelo: {vehiculo.modelo}</p>
                                </td>
                                <td>${vehiculo.precio}</td>
                            </tr>
                        </tbody>
                    </table>
                    <center><strong>ESTE RECIBO NO SERA VALIDO SIN FIRMA DEL CAJERO</strong></center>
                    <p style={{ fontSize: 12 }}>
                        Antes de firmar de conformidad la entrega del pedimento de importacion, debera cotejar la documentacion y datos, revisar que esta correctamente elaborado y que contenga toda la
                        documentacion requerida. Asi tambien debera asegurarse que el vehiculo se presente ante la autoridad aduanera en un plazo no mayor a 72 horas; en caso contrario, reportar inmediatamente
                        estas anomalias a esta oficina para llevar a cabo los efectos conducentes. Con esto evitara posibles multas relativas al tramite aduanero.
                        El monto cobrado por este recibo es solo por el servicio de elaboracion de pedimento. Esta oficina no realiza el CRUCE o traslado del vehiculo de Juarez a El Paso o El Paso a Juarez para su
                        presentacion ante las autorizades en la aduana. Esta oficina no se hace responsable por daÑos o fallas mecanicas Y/O electricas que se presenten en su vehiculo en el proceso de su importacion. Si
                        el vehiculo no se presenta ante la aduana correspondiente para su modulacion, la rectificacion tiene un costo de $ 2500.00 m.n. Si por cualquier razon decide cancelar el tramite de importacion, se
                        realizara un descuento de $3,000.00 M.N.del total de este recibo por concepto de Sello del titulo, Shipper electronico y Certificado de emisiones americanas. Si a los 30 dias de emitido el pedimento
                        no se ha presentado el vehiculo ante la aduana correspondiente, se pierde el costo total de este recibo. ACEPTAR Y FIRMAR ESTE RECIBO ES ACEPTAR LAS CONDICIONES DEL MISMO
                    </p>
                </div>
            </Modal>
            <Modal
                width='80%'
                visible={modalVehiculo}
                title={vehiculo.marca + ' ' + vehiculo.modelo + ': introduce tus datos para descargar la cotizacion'}
                onCancel={() => setModalVehiculo(false)}
                cancelText='Cerrar'
                okText={<p style={{ color: '#fff' }}>Descargar</p>}
                okButtonProps={{ form: 'data', key: 'submit', htmlType: 'submit' }}
            >
                <Form
                    name='data'
                    onFinish={data => db.collection('cotizaciones').add({...data, fecha: new Date()}).then(() => { pdfrecibo() })}
                >
                    <Form.Item
                        name="email"
                        label="Correo"
                        rules={[
                            {
                                type: 'email',
                                message: 'Introduce un correo valido!',
                            },
                            {
                                required: true,
                                message: 'Porfavor introduce tu correo!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="phone"
                        label="Telefono"
                        rules={[
                            {
                                
                                message: 'Introduce un numero telefonico valido!',
                            },
                            { required: true, message: 'Please input your phone number!' }
                        ]}
                    >
                        <Input
                            addonBefore={
                                <Form.Item name="lada" noStyle>
                                    <Select style={{ width: 70 }}>
                                        <Option value="+52">+52</Option>
                                        <Option value="+1">+1</Option>
                                    </Select>
                                </Form.Item>
                            } style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                width='100%'
                bosyStyle={{ height: 500 }}
                visible={modalPagina}
                title='Hola'
                onCancel={() => setModalPagina(false)}
                cancelText='Cerrar'
                okText='Descargar'
            >
                <iframe width='100%' height='1000' src='https://www.autocheck.com/vehiclehistory/?siteID=0' />
            </Modal>
        </div>
    )
}

export default Searchbar









// WEBPACK FOOTER //
// ./src/components/Searchbar.jsx